const DEFAULT_INTERNAL_ENTRY_TOKEN =
  "ffdfb02341ac8dbfce14598bde857f983d436a16eeac65a7473b8ea9207e5580c9ddb8133b449012316c506986e53a26";

export const INTERNAL_ENTRY_TOKEN =
  process.env.REACT_APP_INTERNAL_ENTRY_TOKEN ||
  DEFAULT_INTERNAL_ENTRY_TOKEN;

export const INTERNAL_ENTRY_BASE = `/${INTERNAL_ENTRY_TOKEN}`;

export const INTERNAL_ROUTES = {
  home: `${INTERNAL_ENTRY_BASE}/job`,
  job: `${INTERNAL_ENTRY_BASE}/job`,
  driver: `${INTERNAL_ENTRY_BASE}/driver`,
  vehicle: `${INTERNAL_ENTRY_BASE}/vehicle`,
  report: `${INTERNAL_ENTRY_BASE}/report`,
  chat: `${INTERNAL_ENTRY_BASE}/chat`,
  common: `${INTERNAL_ENTRY_BASE}/common`,
  company: `${INTERNAL_ENTRY_BASE}/company`,
  settings: `${INTERNAL_ENTRY_BASE}/settings`,
};

export const INTERNAL_FEATURE_PATHS = Object.freeze([
  "job",
  "driver",
  "vehicle",
  "report",
  "chat",
  "common",
  "company",
  "settings",
]);

export function isInternalPath(pathname) {
  if (typeof pathname !== "string") return false;
  const cleanPath = pathname.split(/[?#]/, 1)[0];
  return cleanPath === INTERNAL_ENTRY_BASE ||
    cleanPath.startsWith(`${INTERNAL_ENTRY_BASE}/`);
}

export function isAllowedInternalPath(pathname) {
  const cleanPath =
    typeof pathname === "string" ? pathname.split(/[?#]/, 1)[0] : "";
  if (!isInternalPath(cleanPath)) return false;
  const segments = cleanPath
    .slice(INTERNAL_ENTRY_BASE.length)
    .split("/")
    .filter(Boolean);
  return INTERNAL_FEATURE_PATHS.includes(segments[0]);
}

export function internalPathForFeature(feature) {
  return INTERNAL_ROUTES[feature] || INTERNAL_ROUTES.home;
}

export default INTERNAL_ROUTES;
